import type { FC } from 'react';

import { Terms } from '@/features/privacy/components/Terms';

export const LegalScreen: FC = () => <Terms />;
